import Link from 'next/link'
import styled, { css } from 'styled-components'
import { ArrowRight } from 'svgIcons'

const CompanyScrapEmpty = () => {
  return (
    <StyledWrapper>
      <div className="empty-title">관심설정한 기업이 없습니다.</div>
      <div className="empty-subtitle">
        관심있는 기업을 팔로우하고, <br /> 채용소식과 합격정보를 가장 빠르게
        받아보세요!
      </div>
      <Link href="/company-info">
        <a className="move-button">
          관심기업 설정하러 가기
          <ArrowRight width={14} height={14} />
        </a>
      </Link>
    </StyledWrapper>
  )
}

export default CompanyScrapEmpty

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.line.line_3};
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 78px 0;
    gap: 10px;
    .empty-title {
      font-size: 20px;
      font-weight: 500;
    }
    .empty-subtitle {
      padding-bottom: 10px;
      font-size: 16px;
      font-weight: 500;
      color: ${theme.color.text_2};
      text-align: center;
    }
    .move-button {
      background: white;
      border: none;
      width: 189px;
      height: 44px;
      border-radius: 8px;
      color: ${theme.background.bg_8};
      background: ${theme.color.primary_2};
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      font-size: 14px;
      font-weight: bold;
      text-align: center;
    }
  `}
`
